import { useEffect } from 'react'
import { useModal } from "../contexts/Modal.context"
import { motion, AnimatePresence } from "framer-motion"
import { FiInfo, FiX } from 'react-icons/fi'
import { FaRegCheckCircle } from 'react-icons/fa'

export default function ToastNotifications() {
    const { notifier, deNotify } = useModal()

    return (
        <ul style={{ zIndex: 999 }} className={`w-full max-w-md flex flex-col bg-transparent absolute top-0 z-50 space-y-4 ${notifier.length ? "py-6" : ""}`}>
            <AnimatePresence initial={false}>
                {
                    notifier.map(toast =>
                        <Toast
                            key={toast.id}
                            variant={toast.variant}
                            message={toast.message}
                            close={() => deNotify(toast.id)}
                        />
                    )
                }
            </AnimatePresence>
        </ul>
    )
}

function Toast({ message, variant, close }) {
    const { styles, icon } = getStyles()

    function getStyles() {
        switch (variant) {
            case "error":
                return {
                    styles: "bg-white border-l-8 border-red-600 text-red-600",
                    icon: <FiInfo className="text-2xl" />
                }
            default:
                return {
                    styles: "bg-white border-l-8 border-indigo-600 text-indigo-600",
                    icon: <FaRegCheckCircle className="text-2xl" />
                }
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            close()
        }, 10000);

        return () => clearTimeout(timer)
        // eslint-disable-next-line
    }, []);

    return (
        <motion.li
            positionTransition
            initial={{ opacity: 0, y: -20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1, transition: { type: "tween", duration: 0.3 } }}
            exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
            className={`px-4 py-3 h-20 w-full flex items-center space-x-3 rounded-lg shadow-lg ${styles}`}
        >
            {icon}
            <p className={`flex-1 truncate`}>{message}</p>
            <div className="h-full grid place-items-center" onClick={close}>
                <FiX className="text-2xl cursor-pointer" />
            </div>
        </motion.li>

    )
}
